import { render, staticRenderFns } from "./icon-label.vue?vue&type=template&id=25f7811b&"
import script from "./icon-label.vue?vue&type=script&lang=js&"
export * from "./icon-label.vue?vue&type=script&lang=js&"
import style0 from "./icon-label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports